// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1gt6s","title":"AfterBackImages_title__33e8E","images":"AfterBackImages_images__1Petb"};